import { render, staticRenderFns } from "./SummaryTheme.vue?vue&type=template&id=d0228f28&scoped=true&"
import script from "./SummaryTheme.vue?vue&type=script&lang=js&"
export * from "./SummaryTheme.vue?vue&type=script&lang=js&"
import style0 from "./SummaryTheme.vue?vue&type=style&index=0&id=d0228f28&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d0228f28",
  null
  
)

export default component.exports